import {
  StatusChipV2,
  StatusChipV2Color,
  StatusChipV2Props,
} from '@cast/design-system';

type Props = {
  testId?: string;
  icon?: React.ReactNode;
  label: string;
  color?: StatusChipV2Color;
} & Pick<StatusChipV2Props, 'sx'>;

export const HpaSettingsTabChip = ({
  testId = 'hpa-settings-tab-chip',
  icon,
  label,
  color = 'neutral',
  sx,
}: Props) => {
  return (
    <StatusChipV2
      testId={testId}
      size="small"
      color={color}
      variant="subtle"
      label={label || undefined}
      slots={icon ? { icon } : undefined}
      sx={sx}
    />
  );
};
